import { render, staticRenderFns } from "./AvatarUploader.vue?vue&type=template&id=7e4c58fc"
import script from "./AvatarUploader.vue?vue&type=script&lang=js"
export * from "./AvatarUploader.vue?vue&type=script&lang=js"
import style0 from "./AvatarUploader.vue?vue&type=style&index=0&id=7e4c58fc&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4c58fc')) {
      api.createRecord('7e4c58fc', component.options)
    } else {
      api.reload('7e4c58fc', component.options)
    }
    module.hot.accept("./AvatarUploader.vue?vue&type=template&id=7e4c58fc", function () {
      api.rerender('7e4c58fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AvatarUpload/AvatarUploader.vue"
export default component.exports